import React from 'react';
import { Select, Avatar, Space, Tooltip, SelectProps } from 'antd';
import { Page } from '../../types';

const { Option } = Select;

interface PageSelectProps extends Omit<SelectProps, 'options'> {
  pages: Page[];
  isPageDisabled?: (pageId: string) => boolean | { disabled: boolean; message: string };
}

const PageSelect: React.FC<PageSelectProps> = ({ 
  pages, 
  isPageDisabled, 
  placeholder = "Chọn trang...", 
  ...props 
}) => {
  return (
    <Select
      placeholder={placeholder}
      optionFilterProp="label"
      {...props}
    >
      {pages.map(page => {
        const disabledInfo = isPageDisabled?.(page.id);
        const disabled = typeof disabledInfo === 'object' ? disabledInfo.disabled : !!disabledInfo;
        const tooltipMessage = typeof disabledInfo === 'object' ? disabledInfo.message : "Trang này không khả dụng";

        const content = (
          <Space>
            <Avatar src={page.pictureUrl} size="small" />
            {page.name}
          </Space>
        );

        return (
          <Option 
            key={page.id} 
            value={page.id} 
            label={page.name} // This is used for searching
            disabled={disabled}
          >
            {disabled ? (
              <Tooltip title={tooltipMessage}>
                {content}
              </Tooltip>
            ) : content}
          </Option>
        );
      })}
    </Select>
  );
};

export default PageSelect;
